import React, { createContext, useContext } from 'react';
import useAzureIpHook from '../../../hooks/Dashboard/azure/useIp';

export const AzureIpContext = createContext();

export const AzureIpProvider = ({ children }) => {
  const data = useAzureIpHook(); // Import everything from the hook

  return (
    <AzureIpContext.Provider value={data}>
      {children}
    </AzureIpContext.Provider>
  );
};

export const useAzureIp = () => useContext(AzureIpContext);